<!-- <h3 class="header-label  text-center ">{{ 'HOME.ACCOUNT_INFO' | translate }}</h3> -->
<!-- <div class="row pt-3 d-flex justify-content-center align-items-center">
    <div class="col-12 col-md-7 responsive-center ">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.PLAYLIST_NAME' | translate }}</span>
      <div class="pl-md-3 pl-1 field-label">:</div>
      <div class=" pl-md-3 px-2 field-value">{{playlist?.playlist_name}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center ">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER1' | translate }}</span>
      <div class="pl-md-3 pl-1 field-label">:</div>
      <div class=" pl-md-3 px-2 field-value">{{authuser?.user_info.username}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER2' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{authuser?.user_info.status}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER3' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{authuser?.user_info.is_trial == 0 ? 'No':'Yes'}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER4' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{authuser?.user_info.active_cons}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER6' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{mjm}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER7' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{mjm1}}</div>
    </div>
  </div>
  <div class="col-12 col-md-7 responsive-center">
    <div class="user-data-feild mb-3 d-flex py-2">
      <span class="ml-3 field-label">{{ 'USERINFO.USER5' | translate }}</span>
      <div class="ml-3 field-label">:</div>
      <div class="pl-md-3 px-2 field-value">{{authuser?.user_info.max_connections}}</div>
    </div>
  </div>
</div> -->

<div class="account-info-section text-light text-center">
  <h3 class="mt-3 mb-4">{{ 'HOME.ACCOUNT_INFO' | translate }}</h3>

  <div class="mx-auto text-center" style="max-width: 500px;width: auto;padding-left: 20px;">
    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.PLAYLIST_NAME' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{ playlist?.playlist_name }}</div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.USER1' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{ authuser?.user_info.status }}</div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.USER2' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{ authuser?.user_info.is_trial == 0 ? 'No' : 'Yes' }}</div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.USER4' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{ authuser?.user_info.active_cons }}</div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.USER6' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{mjm}}</div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="field-label w-50">{{ 'USERINFO.USER7' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{mjm1}}</div>
    </div>

    <div class="d-flex justify-content-between mb-4">
      <div class="field-label w-50">{{ 'USERINFO.USER5' | translate }}</div>
      <!-- <div class="w-10 text-center">:</div> -->
      <div class="field-value w-50"><span class="pr-5">:</span>{{ authuser?.user_info.max_connections }}</div>
    </div>

    
  </div>
</div>




<!-- <div class="text-center mt-5">
  <button *ngIf="isLocal === true" style="width: 200px;" class="logout-btn" (click)="logout()">
    <i class="fa fa-sign-in text-white fs-20 mr-2 ml-0" aria-hidden="true"></i>
    {{ 'HOME.LOGOUT' | translate }}
  </button>
  <button *ngIf="isLocal === false" style="width: 200px;" class="logout-btn" (click)="login()">
    <i class="fa fa-login">{{'COMMON.LOGIN' | translate}}</i>
  </button>
</div> -->